import { contentListQueries } from '../../queries';
import { queryClient } from 'src/config/request';
import { DataHubService } from 'src/core/services/datahub';
import { TryContentOrderPageSchema } from 'src/core/services/datahub/schemas/moduleList/tryContentOrderPageSchema';
export function dispatchTryContentOrderPageEvent({ moduleId, targetModuleId, initialIndex, targetIndex, statusCode, isExtraModule, result, failureDescription }) {
    const modulesList = queryClient.getQueryData(contentListQueries.getModules({ extra: isExtraModule }).queryKey);
    const moduleInitialOrder = modulesList?.findIndex((module) => module.id === moduleId) ?? -1;
    const moduleFinalOrder = modulesList?.findIndex((module) => module.id === targetModuleId) ?? -1;
    DataHubService.sendEvent({
        schema: new TryContentOrderPageSchema({
            result,
            failureDescription,
            moduleInitialOrder,
            moduleFinalOrder,
            moduleInitialId: moduleId,
            moduleFinalId: targetModuleId ?? '',
            pageInitialOrder: initialIndex,
            pageFinalOrder: targetIndex,
            statusCode
        })
    });
}
